import type { PaymentPlatform, PurchaseErrorIntent } from '@forest/paywall-core'

/**
 * Whether a classified purchase error is an abandoned checkout: the user
 * dismissed the native store payment sheet themselves (see GLOSSARY.md ›
 * Abandoned checkout). Only the `interrupted` sub-case of `payment_timeout`
 * qualifies, and only on iOS / Google Play — on China Android the same native
 * result has an uncertain payment outcome (ADR 0008), so it is not an
 * abandoned checkout.
 */
export function isAbandonedCheckout(
  intent: PurchaseErrorIntent,
  platform: PaymentPlatform,
): boolean {
  return (
    intent.kind === 'payment_timeout' &&
    intent.detail === 'interrupted' &&
    platform !== 'china_android'
  )
}
